import { observable } from 'mobx';

export default class StoreToppingModel {
  toppingCode;
  name;
  addCode;
  addPrice;
  addRdPrice;
  isSelect;
  isSoldOut;
  maxCount;

  @observable isChecked;
  @observable qty = 1;

  constructor(data) {
    Object.assign(this, data);
  }
}
